export default {"src":"/_next/static/media/AppDownloadGooglePlayWhite.233988c0.svg","height":55,"width":176,"blurWidth":0,"blurHeight":0};